<template>
    <div>
        <header-notification
            :isHasSubscriptionMessage="isHasSubscriptionMessage"
            @visible="handleHeaderNotificationVisibility"
            ref="notificationBanner"
        />
        <subscription
            @visible="handleHeaderNotificationVisibility"
            @hasSubscriptionMessage="
                value => {
                    isHasSubscriptionMessage = value;
                }
            "
        />
        <b-navbar
            id="app-primary-nav"
            toggleable="lg"
            type="dark"
            variant="dark"
            class="pt-2 pb-0 bg-new-theme"
            style="margin-bottom: -1px;"
        >
            <input
                type="hidden"
                id="vet_current_staff_id"
                name="vet_current_staff_id"
                :value="currentActor ? currentActor.id : ''"
            />
            <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
            <b-navbar-brand class="px-2">
                <img src="assets/daysmartvet_logo.svg" width="37" />
            </b-navbar-brand>
            <b-collapse id="nav_collapse" is-nav>
                <b-navbar-nav id="nav_module_menu">
                    <b-nav-item
                        to="/schedule"
                        v-if="_hasAccess('schedule.access')"
                        :active="
                            $route.path.includes('schedule') ||
                            reportTabScheduleActive === true
                        "
                        class="main-menu-item"
                        data-top-menu-id="schedule"
                    >
                        <module-icon class="icon" name="schedule" />
                        <span class="label">Schedule</span>
                    </b-nav-item>
                    <b-nav-item
                        to="/patient"
                        v-if="_hasAccess('patient.access')"
                        :active="$route.path.includes('patient')"
                        class="main-menu-item"
                        data-top-menu-id="patients"
                    >
                        <module-icon class="icon" name="patients" />
                        <span class="label">Patients</span>
                    </b-nav-item>
                    <b-nav-item
                        to="/client"
                        v-if="_hasAccess('client.access')"
                        :active="$route.path.includes('client')"
                        class="main-menu-item"
                        data-top-menu-id="clients"
                    >
                        <module-icon class="icon" name="clients" />
                        <span class="label">Clients</span>
                    </b-nav-item>
                    <b-nav-item
                        to="/contact"
                        v-if="_hasAccess('contact.access')"
                        :active="$route.path.includes('contact')"
                        class="main-menu-item"
                        data-top-menu-id="contacts"
                    >
                        <module-icon class="icon" name="contacts" />
                        <span class="label">Contacts</span>
                    </b-nav-item>
                    <b-nav-item
                        v-if="_hasAccess('inventory.access')"
                        to="/inventory"
                        :active="$route.path.includes('inventory')"
                        class="main-menu-item"
                        data-top-menu-id="inventory"
                    >
                        <module-icon class="icon" name="inventory" />
                        <span class="label">Inventory</span>
                    </b-nav-item>
                    <b-nav-item
                        v-if="_hasAccess('billing.access')"
                        to="/billing"
                        :active="
                            $route.path.includes('billing') ||
                            $route.name ==
                                'direct-url-billing-invoice-profile' ||
                            $route.name == 'direct-url-billing-estimate-profile'
                        "
                        class="main-menu-item"
                        data-top-menu-id="billing"
                    >
                        <module-icon class="icon" name="billing" />
                        <span class="label">Billing</span>
                    </b-nav-item>
                    <b-nav-item
                        to="/report"
                        v-if="_hasAccess('report.access')"
                        :active="
                            $route.path.includes('report') &&
                            reportTabScheduleActive === false
                        "
                        class="main-menu-item"
                        data-top-menu-id="reports"
                    >
                        <module-icon class="icon" name="reports" />
                        <span class="label">Reports</span>
                    </b-nav-item>
                    <b-nav-item
                        :href="env.APPS + 'business/business'"
                        v-if="_hasAccess('setting.access')"
                        :active="$route.path.includes('settings')"
                        class="main-menu-item"
                        data-top-menu-id="settings"
                    >
                        <module-icon class="icon" name="settings" />
                        <span class="label">Settings</span>
                    </b-nav-item>
                </b-navbar-nav>
                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto top-options">
                    <business :setting="setting" />
                    <shortcut />
                    <log />
                    <notification-alert
                        v-if="isNotifcationFeatureEnabled"
                        @toggle="toggleAppNotifications"
                    />

                    <nav-item-tasks
                        :showNewTaskModal="showNewTaskModal"
                        :isNotificationEnabled="isNotifcationFeatureEnabled"
                    />
                    <b-nav-item-dropdown
                        data-top-right-id="help"
                        no-caret
                        right
                    >
                        <template slot="button-content">
                            <i
                                class="fas fa-question-circle"
                                :class="{ blink_indicator: hasUnreadNews }"
                                :key="helpIconKey"
                            ></i>
                            <span class="d-lg-none">Help</span>
                        </template>
                        <b-dropdown-item
                            @click="contactSupport"
                            data-top-help-id="helpdesk"
                        >
                            <i
                                class="fas fa-question-circle"
                                style="margin-right: 5px;"
                            ></i>
                            Help Desk
                        </b-dropdown-item>
                        <b-dropdown-item
                            @click="openWhatsNew"
                            data-top-help-id="whats-new"
                        >
                            <i
                                class="fas fa-info-circle"
                                :class="{ blink_indicator: hasUnreadNews }"
                                style="margin-right: 5px;"
                            ></i>
                            What's New
                            <!-- weather_sun -->
                            <!-- star -->
                        </b-dropdown-item>
                        <b-dropdown-item
                            @click="openWorkramp"
                            data-top-help-id="e-learning"
                        >
                            <i
                                class="fas fa-book"
                                style="margin-right: 5px;"
                            ></i>
                            E-Learning
                        </b-dropdown-item>

                        <b-dropdown-divider />
                        <!-- <b-dropdown-item
                            href="http://www.lifelearn-cliented.com/"
                            target="_blank"
                        >
                            <i class="cus-lifelearn"></i>LifeLearn ClientEd
                            Online
                        </b-dropdown-item> -->
                        <b-dropdown-item
                            v-b-modal.modalmmsearch
                            data-top-help-id="merck"
                        >
                            <i class="cus-merck"></i>Merck Vet Manual
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                    <profile :current-actor="currentActor" />
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
        <whats-new ref="whatsNewDiv" />
        <router-view class="route-main-view" />
        <hr class="app-footer" />
        <footer
            style="padding: 0 1rem 1rem 1rem; height: 30px;"
            class="app-footer"
        >
            <p class="float-left">
                <span
                    >© {{ year }} {{ SYSTEM_COMPANY_NAME }}. All rights
                    reserved.</span
                >
            </p>
            <ul class="footer-links float-right">
                <li>
                    <a @click.stop="showTermsModal()" class="footer-link"
                        >Terms of Use</a
                    >
                </li>
                <li>
                    <a @click.stop="showPrivacyModal()" class="footer-link"
                        >Privacy Policy</a
                    >
                </li>
            </ul>
        </footer>
        <notifications
            :width="notification.width"
            group="root"
            position="top center"
            style="top: 19vh;"
            class="shadow rounded"
        >
            <template slot="body" slot-scope="props">
                <b-alert :variant="notification.variant" show class="mb-0">
                    <div class="notification-wrapper-flex">
                        <div
                            class="icon-wrapper"
                            v-show="props.item.data && props.item.data.icon"
                        >
                            <i :class="`cus-${props.item.data.icon}`"></i>
                        </div>
                        <div class="center-side">
                            <div
                                class="notification-title"
                                v-show="props.item.title"
                            >
                                {{ props.item.title }}
                            </div>
                            <div class="content-wrapper">
                                <span
                                    v-html="props.item.text"
                                    class="notification-text"
                                ></span>
                            </div>
                        </div>
                        <a
                            @click="closeNotification(props)"
                            class="close"
                            style="cursor: pointer;"
                            >&times;</a
                        >
                    </div>
                </b-alert>
            </template>
        </notifications>
        <modal-merck />
        <modal-new-task ref="newTaskWindow" />
        <modalTerms ref="termsWindow" />
        <modalPrivacy ref="privacyWindow" />
        <modal-billing-lock />
        <lock />
        <antechUI ref="modalAntechUI" />
        <antechHealthTrackUI ref="modalAntechHealthtrackUI" />
        <idexxSubmit ref="modalIdexxSubmit" />
        <requisitionForm ref="requisitionFormWindow" />
        <multipleRequisitionForm ref="multipleRequisitionFormWindow" />
        <processLoadingBar />
        <app-notification ref="appNotification" />
        <IntercomDialog ref="intercomeMessageDialog" />
    </div>
</template>
<style lang="scss">
@import url("~offline-js/themes/offline-theme-chrome.css");
@import url("~offline-js/themes/offline-language-english.css");

.footer-link {
    color: #7a0000 !important;
    text-decoration: none;
    background-color: transparent;
    cursor: pointer;
}

.footer-links li {
    display: inline;
    margin: 0 0 0 10px;
}

.business-select .box {
    width: 1rem;
    display: inline-block;
}
.notification-wrapper-flex {
    display: flex;

    .icon-wrapper {
        margin-top: 2px;
        margin-right: 5px;
    }

    .center-side {
        flex: 1;

        .notification-title {
            margin-bottom: 4px;
        }
    }
}
.notification-text a {
    font-weight: normal !important;
    text-decoration: underline !important;
    color: #222;
}

#app-primary-nav {
    #nav_collapse {
        svg.icon {
            margin-right: 7px;
            display: inline;
        }
    }

    a.nav-link {
        svg.icon {
            fill: #fff;
            height: 24px;
            width: 24px;
            transition: transform 0.1s ease;
        }

        &:hover,
        &.active {
            svg.icon {
                fill: #190d30;
            }
        }

        &:hover {
            svg.icon {
                transform: scale(1.2);
            }
        }
    }

    .top-options {
        li > a.nav-link > i.fas {
            margin-right: 7px;
        }
    }
}

@media (min-width: 992px) {
    $primary-top-bar-height: 64px;
    $secondary-top-bar-height: 50px;

    // note:
    // annoate image editor zindex = 600
    // default bootstrap dropdown zindex = 1000

    #app-primary-nav {
        margin-bottom: -1px;
        position: fixed;
        z-index: 1002;
        left: 0;
        right: 0;
        height: $primary-top-bar-height;

        #nav_collapse {
            li.main-menu-item {
                width: 5rem;

                a.nav-link {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;

                    svg.icon {
                        margin-right: unset;
                    }

                    span.label {
                        font-size: 1em;
                    }
                }
            }
        }

        .top-options {
            align-items: center;
            flex-wrap: wrap;

            li > a.nav-link {
                padding-left: 10px;
                padding-right: 10px;

                & > i.fas {
                    margin-right: unset;
                }
            }

            li:not(#nav-item-business):not(#nav-item-profile) > a.nav-link {
                transition: transform 0.1s ease;

                &:hover {
                    transform: scale(1.2);
                }
            }
        }
    }

    .route-main-view {
        padding-top: ($primary-top-bar-height - 1) + $secondary-top-bar-height;

        & > .module-navbar,
        & > div > .module-navbar {
            position: fixed;
            top: ($primary-top-bar-height - 1);
            right: 0;
            left: 0;
            z-index: 1001;
            height: $secondary-top-bar-height;
        }
    }
}
</style>
<script>
/**
 * @name LayoutIndex
 * @description This is the layout at highest level for this web application:
 *              - It contains header(top navbar) and footer that displays in every page.
 *              - It includes notification popup component for tasks or any other
 *              notifications messages (ie from function _message()).
 */
import modalTerms from "./terms.vue";
import modalPrivacy from "./privacy.vue";
import modalNewTask from "@/components/tasks/task-update-modal";
import modalMerck from "./merck.vue";
import Business from "./nav-item-business.vue";
import Log from "./nav-item-log.vue";
import Profile from "./nav-item-profile.vue";
import Lock from "./lock.vue";
import Shortcut from "./nav-item-shortcut.vue";
import NotificationAlert from "./nav-item-notifications.vue";
import NavItemTasks from "./nav-item-tasks.vue";
import Subscription from "@/module/subscription/index";
import HeaderNotification from "@/module/commons/header-notification";
import AntechUI from "@/components/commons/antech-ui.vue";
import AntechHealthTrackUI from "@/components/commons/antech-healthtrack-ui.vue";
import IdexxSubmit from "@/module/commons/idexx_submit.vue";
import RequisitionForm from "@/module/commons/print_requisition_form.vue";
import MultipleRequisitionForm from "@/module/commons/print_multiple_requisition_form.vue";
import installStripeRules from "@/module/commons/validator-stripe";
import ProcessLoadingBar from "./process-loading-bar.vue";
import { Validator } from "vee-validate";
import { get, find, assign, clone, forEach } from "lodash";
import ModalBillingLock from "./modal-billing-lock";
import WhatsNew from "@/components/whats-new/whats-new-holder.vue";
import Account from "@/services/account";
import axios from "axios";
import EXTENSIONS from "@/constants/extensions";
import IntercomJsSdk from "@intercom/messenger-js-sdk";
import BETA_RELEASE from "@/constants/beta-release";
import AppNotification from "@/components/notifications/holder.vue"; // Using "app-notification" as there are multiple components with "notifications" name
import notificationIcons from "@/module/commons/notification-icons.js";
import FeaturesEnabledMixin from "@/mixins/features-enabled";
import ModuleIcon from "@/module/layout/module-icon";
import IntercomDialog from "@/module/layout/intercom-dialog";

import "offline-js";
// TODO refactor helper
import ScheduleHelper from "@/module/schedule/helper";
import DialogMixin from "@/mixins/dialog-queue";

export default {
    components: {
        modalTerms,
        modalPrivacy,
        modalNewTask,
        modalMerck,
        Business,
        Log,
        Profile,
        Lock,
        Shortcut,
        Subscription,
        HeaderNotification,
        IdexxSubmit,
        AntechUI,
        AntechHealthTrackUI,
        ModalBillingLock,
        RequisitionForm,
        MultipleRequisitionForm,
        ProcessLoadingBar,
        WhatsNew,
        NotificationAlert,
        NavItemTasks,
        AppNotification,
        ModuleIcon,
        IntercomDialog
    },
    mixins: [ScheduleHelper, DialogMixin, FeaturesEnabledMixin],
    data() {
        return {
            currentActor: null,
            permissions: {},
            setting: {},
            timesheet: {},
            extensions: {},
            notification: {
                variant: "success",
                duration: 3000,
                width: "30%"
            },
            reportTabScheduleActive: false, // open report_detail route, but active tab still remains on Schedule
            USE_CLIENT_MODULE_VUE: process.env.USE_CLIENT_MODULE_VUE === "true",
            USE_CONTACT_MODULE_VUE:
                process.env.USE_CONTACT_MODULE_VUE === "true",
            isHasSubscriptionMessage: true,
            showWhatsNew: false,
            hasUnreadNews: false,
            helpIconKey: 0,
            switcher_event: null
        };
    },
    beforeRouteUpdate(to, from, next) {
        setTimeout(() => {
            this.handleHeaderNotificationVisibility();
        }, 150);

        this.remindersDetailScheduleTab(to, from);
        this.refreshCISession(to, from, next);
        next();
    },
    computed: {
        reportTabActive() {
            return (
                this.$route.path.includes("report") &&
                this.reportTabScheduleActive === false
            );
        },
        year() {
            return moment().format("Y");
        },
        hasUnread() {
            return this.$store.state.conversation.hasUnread;
        },
        isSkipReEnableInvoice() {
            return this.$store.getters["billing/isSkipReEnableInvoice"];
        }
    },
    mounted() {
        // enable access to vue build version
        // eslint-disable-next-line no-undef
        window.vetterVueBuildVersion = APPLICATION_VERSION;

        const settingLoader = [
            this.getBusinessSettings(),
            this.getCurrentStaff(),
            this.getCurrentStaffPermissions(),
            this.getActiveExtension().then(extensions => {
                if (find(extensions, { extension_code: "CC_PROCESSING" })) {
                    this.getPaymentExtension();
                } else if (find(extensions, { extension_code: "GRAVITY" })) {
                    this.addScript(process.env.GRAVITY_ASSETS);
                } else if (find(extensions, { extension_code: "STRIPE" })) {
                    this.getStripeDetails();
                }
            }),
            this.$store.dispatch("loadReference"),
            this.$store.dispatch("checkFeatureEnabled", {
                key: BETA_RELEASE.KEY.NOTIFICATION
            }),
            this.$store.dispatch("checkFeatureEnabled", {
                key: BETA_RELEASE.KEY.CUBEX
            }),
            this.getUserPreferences()
        ];

        Promise.all(settingLoader)
            .then(() => {
                this.$root.$emit("settingLoaded", this.$root.setting);
                this.$store.commit("setting", { value: this.$root.setting });

                // -- datetimepicker init
                // eslint-disable-next-line no-undef
                jQuery.extend(true, jQuery.fn.datetimepicker.defaults, {
                    icons: {
                        time: "far fa-clock",
                        date: "far fa-calendar",
                        up: "fas fa-arrow-up",
                        down: "fas fa-arrow-down",
                        previous: "fas fa-chevron-left",
                        next: "fas fa-chevron-right",
                        today: "fas fa-calendar-check",
                        clear: "far fa-trash-alt",
                        close: "far fa-times-circle"
                    },
                    keyBinds: "t:",
                    format: this.getDateFormat()
                });

                this.registerSocketIO();
                this.$socket.$subscribe(
                    "task:notify:new:" +
                        this.$root.currentActor.id +
                        ":" +
                        this.$root.setting.business_id,
                    () => {
                        this._taskCheck();
                    }
                );

                this.$socket.$subscribe(
                    "task:notify:due:" +
                        this.$root.currentActor.id +
                        ":" +
                        this.$root.setting.business_id,
                    data => {
                        let message = JSON.parse(data);
                        if (message.message) {
                            this._message(
                                `<a href="#" onclick="routerNavigate(event, '/schedule/tasks?status=3')">${message.message}</a>`,
                                "info"
                            );
                        }
                    }
                );

                this.$socket.$subscribe(
                    "reminder-summary:print-letter:" +
                        this.$root.currentActor.id +
                        ":" +
                        this.$root.setting.business_id,
                    data => {
                        let message = JSON.parse(data);
                        if (message && !document.hidden) {
                            this._printLetterSocket(message);
                        }
                    }
                );

                // always reload notification from api
                this._taskCheck();

                if (this._isExtensionEnabled("2_WAY_MESSAGING")) {
                    this.$store.dispatch("conversation/getUnread");
                }

                this.initPendo();
                this.checkHasUnreadNews();

                // eslint-disable-next-line no-undef
                if (newrelic) {
                    // eslint-disable-next-line no-undef
                    newrelic.setCustomAttribute(
                        "businessId",
                        this.$root.setting.business_id,
                        true
                    );
                    // eslint-disable-next-line no-undef
                    newrelic.setCustomAttribute(
                        "staffId",
                        this.$root.currentActor.id,
                        true
                    );
                }
            })
            .finally(() => {
                this.closeLoader();
            });

        //call idexx iframe modal
        this.$root.$on("call_idexx_iframe", labResponse => {
            // this.$refs.modalIdexxSubmit.open(labResponse);
            this.enqueueAndShowDialog("modalIdexxSubmit", labResponse);
        });

        //call antech iframe modal
        this.$root.$on("call-antech-iframe", labResponse => {
            // this.$refs.modalAntechUI.open(labResponse);
            this.enqueueAndShowDialog("modalAntechUI", labResponse);
        });

        //call antech iframe modal
        this.$root.$on("call-antech-healthtracks-iframe", labResponse => {
            // this.$refs.modalAntechHealthtrackUI.open(labResponse);
            this.enqueueAndShowDialog("modalAntechHealthtrackUI", labResponse);
        });

        //call multirequsition form modal
        this.$root.$on("call-multirequsition-modal", labResponse => {
            this.enqueueAndShowDialog(
                "multipleRequisitionFormWindow",
                labResponse
            );
        });

        //call print requisition form modal
        this.$root.$on("call-requisition-modal", labResponse => {
            this.enqueueAndShowDialog("requisitionFormWindow", labResponse);
        });

        this.$root.$on("privacyPolicyModal", () => {
            this.showPrivacyModal();
        });

        this.messageListener();

        // Reset modal data
        this.$root.$on("bv::modal::hidden", (bvEvent /* modalId */) => {
            try {
                assign(
                    bvEvent.vueTarget.$parent.$data,
                    bvEvent.vueTarget.$parent.$options.data()
                );
            } catch (e) {
                console.log(e);
            }
        });
        this.$root.$on("bv::modal::shown", (/* bvEvent, modalId */) => {
            this.$root.$emit("bv::hide::popover");
        });

        this.$store.dispatch("task/checkTaskFeature");

        let self = this;
        this.$root.$on("disable-release-note-blink", () => {
            self.hasUnreadNews = false;
            self.helpIconKey++;
        });

        this.initGlobalToaster();
        document.addEventListener("keydown", this.initShortcutKey);
    },
    sockets: {
        reconnect(/* socket, tryCount */) {
            if (this.setting.business_id) {
                this.registerSocketIO();
            }
        },
        "v-broadcast"(params) {
            let self = this;
            if (
                params.action === "sms-conversation" &&
                this._isExtensionEnabled("2_WAY_MESSAGING")
            ) {
                this.$store.dispatch("conversation/getUnread");
            } else if (
                params.action == "check-notification" &&
                params.businessId == this.$root.setting.business_id
            ) {
                // use timeout to delay a bit for BE process
                let timeout = 1000;

                // for popup message
                if (
                    params &&
                    params.params &&
                    params.params.staffIds.includes(self.$root.currentActor.id)
                ) {
                    // clear all notification
                    self.$notify({
                        group: "root",
                        clean: true
                    });
                    setTimeout(function () {
                        self._taskCheck();
                    }, timeout);
                } else {
                    self._taskCheck();
                }
            } else if (
                params.action === "vetsource-sync-client" &&
                params.businessId == this.$root.setting.business_id
            ) {
                if (params.params["is_pause"] == true) {
                    localStorage.setItem("vetsource_synced", false);
                } else {
                    localStorage.setItem("vetsource_synced", true);
                }
            } else if (params.action === "payment:invoice-changed") {
                this.handlePaymentInvoiceChanged(params);
            }
        },
        "v-broadcast-all"(params) {
            if (
                params.action === "post-switch-instance" &&
                params.userId === this.$root.currentActor.id
            ) {
                if (params.isAutomation) {
                    if (params.instance === localStorage.getItem("instance")) {
                        this.handleReloadPath();
                    } else {
                        return; // Prevent automation refresh if the instance is not the same as in local storage
                    }
                } else {
                    window.location.href = params.url;
                }
            } else if (
                params.action === "notification-alert:update-count" &&
                params.userId === this.$root.currentActor.id
            ) {
                this.handleReceiveNotification(params);
            } else if (
                params.action === "user-prefs-notification-update" &&
                params.userId === this.$root.currentActor.id
            ) {
                this.$store.dispatch("userPreferences/updateLocalPref", {
                    type: "notification",
                    data: params.json,
                    isDataString: true
                });

                this.$store.dispatch("notification/getNotificationCount", {
                    socket: true
                });
            }
        }
    },
    methods: {
        handlePaymentInvoiceChanged(payload) {
            if (this.isSkipReEnableInvoice) {
                // Skip re-enable the invoice as the invoice page will be reloaded
                return;
            }

            this.$store.dispatch("billing/updateUsersChooseInvoice", {
                userId: payload.userId,
                userName: payload.userName,
                invoiceIds: payload.invoiceIds,
                paymentModalId: payload.paymentModalId
            });
        },
        handleReloadPath() {
            let routeMaps = {
                patient_profile: "patient_dashboard",
                patient_image_annotate: "patient_dashboard",
                letter: "patient_dashboard",
                lab: "patient_dashboard",
                patient_webform: "patient_dashboard",
                soap: "patient_dashboard",
                client_profile: "client_dashboard",
                client_letter: "client_dashboard",
                client_webform: "client_dashboard",
                contact_actor: "contact_dashboard",
                contact_company: "contact_dashboard",
                item: "inventory_dashboard",
                purchase_order: "inventory_dashboard",
                receipt: "inventory_dashboard",
                invoice: "billing_dashboard",
                estimate: "billing_dashboard",
                return: "billing_dashboard",
                custom_report: "report_dashboard",
                staff_profile: "staff_setting"
            };

            let redirectToMap = routeMaps[this.$route.name];

            // special for template details (as it is nested)
            if (!redirectToMap && this.$route.name === "template_details") {
                window.location.href = "view/settings/template/all";
            }
            // specific id --> redirect to parent
            else if (redirectToMap) {
                let resolve = this.$router.resolve({ name: redirectToMap });
                window.location.href = resolve.href;
            }
            // refresh as is
            else {
                window.location.reload();
            }
        },
        checkSwitchInstance() {
            this.switcher_event = setInterval(() => {
                if (!this.$cookies.get("active_business_id")) {
                    if (typeof newrelic !== "undefined") {
                        // eslint-disable-next-line no-undef
                        newrelic.addPageAction("view-logout", {
                            reason: "switch instance , no bid",
                            file: "index.vue"
                        });
                    }
                    this._redirect(
                        process.env.APPS + "index.php/welcome/logout"
                    );
                    clearInterval(this.switcher_event);
                }
            }, 1000);
        },
        remindersDetailScheduleTab(to, from) {
            if (to.name === "report_detail" && to.params.id == "reminder") {
                this.reportTabScheduleActive = true;
            } else {
                this.reportTabScheduleActive = false;
            }
        },
        getBusinesses() {
            let self = this;
            if (self.businesses.length === 0) {
                this.$http
                    .get(process.env.ACTOR_SERVICE + "staff/businesses")
                    .then(function (response) {
                        self.businesses = response.data.response.resources;
                    });
            }
        },
        getCurrentStaff() {
            let self = this;
            return this.$http
                .get(process.env.ACTOR_SERVICE + "staff/current")
                .then(function (response) {
                    self.currentActor = response.data.response.resource.actor;
                    self.currentActor.relation =
                        response.data.response.resource.relation;
                    self.timesheet = response.data.response.resource.timesheet;
                    self.$root.currentActor = clone(self.currentActor);
                    self.$root.timesheet = clone(self.timesheet);
                    localStorage.setItem(
                        "my_staff_url",
                        self.$root.currentActor.ci_url
                    );
                    localStorage.setItem(
                        "my_staff_initials",
                        self.getActorInitials(self.currentActor)
                    );
                    if (response.data.response.resource.intercom_data) {
                        self.$root.intercomData =
                            response.data.response.resource.intercom_data;
                        localStorage.setItem(
                            "intercomData",
                            JSON.stringify(self.$root.intercomData)
                        );
                        IntercomJsSdk(self.$root.intercomData);
                    }
                    return self.$root.currentActor;
                });
        },
        getCurrentStaffPermissions() {
            let self = this;
            return this.$http
                .get(process.env.ACTOR_SERVICE + "staff/current/permissions")
                .then(function (response) {
                    self.permissions = response.data.response.resource;
                    self.$root.permissions = clone(self.permissions);
                });
        },
        async messageListener() {
            let self = this;
            this.$root.$on("message", function (
                message,
                variant,
                duration,
                width,
                params,
                title = ""
            ) {
                if (!message) {
                    return;
                }

                self.forceCloseNotifications();

                let icon = null;
                self.notification.width = width ? width : getDefaultWidth();
                self.notification.variant = variant
                    ? variant
                    : self.notification.variant;

                switch (variant) {
                    case "success":
                        icon = "accept";
                        break;
                    case "danger":
                        icon = "exclamation";
                        break;
                    case "warning":
                        icon = "error";
                        break;
                    case "info":
                        icon = "information";
                        break;
                    default:
                        break;
                }

                let notificationOptions = {
                    group: "root",
                    duration:
                        duration === true
                            ? -1
                            : duration
                            ? duration
                            : self.notification.duration,
                    closeOnClick: false,
                    text: message,
                    title: title,
                    data: {
                        icon: icon || null
                    }
                };

                if (get(params, "id")) {
                    notificationOptions.id = params.id;
                }

                self.$notify(notificationOptions);

                if (get(params, "close-callback")) {
                    self.$once("close-callback", params["close-callback"]);
                }
            });

            this.$root.$on("close-message", function (messageId, params) {
                if (!messageId) {
                    return;
                }
                self.$notify.close(messageId);
            });
            function getDefaultWidth() {
                return window.innerWidth < 860 ? "80%" : "30%";
            }
        },
        getBusinessSettings() {
            let self = this;
            // -- https://stackoverflow.com/a/22969338
            let ntp = function (t0, t1, t2, t3) {
                return {
                    roundtripdelay: t3 - t0 - (t2 - t1),
                    offset: (t1 - t0 + (t2 - t3)) / 2
                };
            };
            let t0 = new Date().valueOf();
            return this.$http
                .get(process.env.BARRACUDA + "account/setting")
                .then(response => {
                    self.setting = response.data.response.resource;
                    self.$root.setting = clone(this.setting);

                    this.checkSwitchInstance();

                    let t1 = self.$root.setting.serverTime,
                        t2 = self.$root.setting.serverTime,
                        t3 = new Date().valueOf();

                    self.$root.setting.serverTime = ntp(t0, t1, t2, t3);

                    this.$http
                        .get(
                            process.env.BARRACUDA +
                                "account/setting/currency-symbol"
                        )
                        .then(response => {
                            self.$root.setting.currency_symbol =
                                response.data.response.resource;
                            this.$store.commit(
                                "setCurrency",
                                response.data.response.resource
                            );
                        });
                });
        },
        async getUserPreferences() {
            await this.$store.dispatch("userPreferences/initGetPrefs");
        },
        registerSocketIO() {
            this.$socket.client.emit("v-register", {
                businessId: this.setting.business_id
            });
        },
        forceCloseNotifications() {
            let notifications = document.getElementsByClassName(
                "vue-notification-wrapper"
            );

            forEach(notifications, function (notification) {
                notification.style.display = "none";
            });
        },
        closeNotification(props) {
            props.close();
            this.$emit("close-callback");
        },
        getActiveExtension() {
            let self = this;
            return this.$http
                .get(process.env.ACCOUNT_SERVICE + "extension")
                .then(response => {
                    self.extensions = response.data.response.resources;
                    self.$root.extensions = clone(this.extensions);
                    return self.extensions;
                });
        },
        /**
         * Gets called when the clinics have CC processing. Either CCONNECT or
         * STRIPE
         */
        getPaymentExtension() {
            let self = this;
            return this.$http
                .get(process.env.ACCOUNT_SERVICE + "extension/CC_PROCESSING")
                .then(response => {
                    let data = response.data.response.resources;
                    self.$root.cc_extension["processor"] = get(
                        data,
                        "cc_processor"
                    );

                    if (self.$root.cc_extension["processor"] === "STRIPE") {
                        self.addScript("https://js.stripe.com/v2/");
                        self.$root.cc_extension["STRIPE_PUBLIC_KEY"] = get(
                            data,
                            "cc_property.STRIPE_PUBLIC_KEY"
                        );
                        installStripeRules(Validator);
                    }
                    return self.$root.cc_extension["processor"];
                });
        },
        /**
         * Gets called when the clinics have STRIPE PAYMENT enable
         */
        getStripeDetails() {
            let self = this;
            return this.$http
                .get(process.env.BARRAMUNDI + "payment/stripe/account/detail")
                .then(response => {
                    let data = response.data.response.message.data;
                    if (response.data.response.message.code == 200) {
                        self.$root.cc_extension["processor"] = "STRIPE";
                        self.$root.cc_extension["STRIPE_PUBLIC_KEY"] = get(
                            data,
                            "public_key"
                        );
                        self.$root.cc_extension["STRIPE_ACCOUNT_ID"] = get(
                            data,
                            "account_id"
                        );
                    }
                });
        },
        async getSalesforceUsername() {
            const SF_USERNAME = "sf_username";
            let storedUsername = localStorage.getItem(SF_USERNAME);

            if (storedUsername && storedUsername !== "") {
                return storedUsername; // return saved username if any
            }

            let res = await axios.get(
                `${process.env.BARRAMUNDI}actor/salesforce/userid`
            );

            let result = res.data;
            if (result === "error" || result === "ERROR") {
                throw new Error("Error: Unable to get username.");
            }

            // set username in local storage
            localStorage.setItem(SF_USERNAME, result);

            return result;
        },
        async supportLink() {
            // salesforce
            const ERR_MESSAGE = "Unable to connect Help Desk SSO.";
            let preloader = document.getElementById("helpDeskOverlay");

            try {
                preloader.style.display = "flex";

                let samlGatewayURL =
                    process.env.SAML_GATEWAY_URL || "http://localhost:8081";

                let userName = await this.getSalesforceUsername();

                if (!userName || userName === "") {
                    throw new Error(ERR_MESSAGE);
                }

                let res = await axios.post(`${samlGatewayURL}/signin`, {
                    userName
                });

                preloader.style.display = "none";

                if (res.data.success) {
                    let form = document.createElement("form");
                    form.method = "post";
                    form.action = res.data.AcsUrl;
                    form.target = "_blank";
                    form.name = "hiddenform";

                    let inputResponse = document.createElement("input");
                    inputResponse.type = "hidden";
                    inputResponse.name = "SAMLResponse";
                    inputResponse.value = res.data.SAMLResponse;

                    let inputRelay = document.createElement("input");
                    inputRelay.type = "hidden";
                    inputRelay.name = "RelayState";
                    inputRelay.value = res.data.RelayState;

                    form.appendChild(inputResponse);
                    form.appendChild(inputRelay);

                    document.body.appendChild(form);
                    form.submit();
                    form.remove();
                } else {
                    throw new Error(ERR_MESSAGE);
                }
            } catch (error) {
                preloader.style.display = "none";
                this._message(error.message, "danger");
            }
        },
        openLock() {
            this.$refs["lockModal"].open();
        },
        closeLoader() {
            document.getElementById("the-heartbeat").style.display = "none";
        },
        showTermsModal() {
            this.$refs.termsWindow.open();
        },
        showPrivacyModal() {
            this.$refs.privacyWindow.open();
        },
        showNewTaskModal() {
            this.$refs.newTaskWindow.open();
        },
        openWhatsNew() {
            this.$refs.whatsNewDiv.open();
        },
        checkHasUnreadNews() {
            this.hasUnreadNews = false;
            let currentActor = this.$root.currentActor;

            Account.getReleaseNotes({ perPage: 10, page: 1 }).then(response => {
                if (response.message.code === 200 && response.resources) {
                    if (response.meta && response.meta.total > 0) {
                        this.hasUnreadNews =
                            currentActor.release_note_id !=
                            response.resources[0].id;
                    }
                }
            });
        },
        initPendo() {
            let currentActor = this.$root.currentActor;
            let setting = this.$root.setting;
            let { CODE } = EXTENSIONS;
            let extensions = {
                [CODE.CODE_SMS]: this._isExtensionEnabled(CODE.CODE_SMS), // SMS 1 Way
                [CODE.CODE_2_WAY_MESSAGING]: this._isExtensionEnabled(
                    CODE.CODE_2_WAY_MESSAGING
                ), // SMS 2 Way
                [CODE.CODE_CLIENT_MOBILE_APP]: this._isExtensionEnabled(
                    CODE.CODE_CLIENT_MOBILE_APP
                ), // PetCare
                [CODE.INTEGRATED_PAYMENTS]:
                    this._isExtensionEnabled(CODE.CODE_CCONNECT) ||
                    this._isExtensionEnabled(CODE.CODE_GRAVITY) ||
                    this._isExtensionEnabled(CODE.CODE_STRIPE), // check if any one of these is enabled : CCONNECT, STRIPE, GRAVITY
                [CODE.CODE_CCONNECT]: this._isExtensionEnabled(
                    CODE.CODE_CCONNECT
                ), // Card Connect
                [CODE.CODE_GRAVITY]: this._isExtensionEnabled(
                    CODE.CODE_GRAVITY
                ), // Gravity
                [CODE.CODE_STRIPE]: this._isExtensionEnabled(CODE.CODE_STRIPE), // Stripe

                [CODE.CODE_ANTECH]: this._isExtensionEnabled(CODE.CODE_ANTECH), // Antech
                [CODE.CODE_IDEXX]: this._isExtensionEnabled(CODE.CODE_IDEXX), // Idexx
                [CODE.CODE_ASTERIS]: this._isExtensionEnabled(
                    CODE.CODE_ASTERIS
                ), // Asteris
                [CODE.CODE_ZNLABS]: this._isExtensionEnabled(CODE.CODE_ZNLABS), // Znlabs
                [CODE.CODE_IDEXX_DR]: this._isExtensionEnabled(
                    CODE.CODE_IDEXX_DR
                ), // Idexx Dr
                [CODE.CODE_NBIOVET]: this._isExtensionEnabled(
                    CODE.CODE_NBIOVET
                ), // Nbiovet
                [CODE.CODE_MIDWEST]: this._isExtensionEnabled(
                    CODE.CODE_MIDWEST
                ), // Midwest
                [CODE.CODE_ALLY_DVM]: this._isExtensionEnabled(
                    CODE.CODE_ALLY_DVM
                ), // allyDVM
                [CODE.CODE_BIVVY]: this._isExtensionEnabled(CODE.CODE_BIVVY), // BIVVY
                [CODE.CODE_TRUPANION]: this._isExtensionEnabled(
                    CODE.CODE_TRUPANION
                ), // Trupanion
                [CODE.CODE_AUTOREMIND]: this._isExtensionEnabled(
                    CODE.CODE_AUTOREMIND
                ), // Auto remind
                [CODE.CODE_DFORCE_API]: this._isExtensionEnabled(
                    CODE.CODE_DFORCE_API
                ), // Demand force
                [CODE.CODE_NEXTINLINE]: this._isExtensionEnabled(
                    CODE.CODE_NEXTINLINE
                ), // Next in line
                [CODE.CODE_PETDESK]: this._isExtensionEnabled(
                    CODE.CODE_PETDESK
                ), // Petdesk
                [CODE.CODE_VETSTORIA]: this._isExtensionEnabled(
                    CODE.CODE_VETSTORIA
                ), // Vetstoria
                [CODE.CODE_VITUSVET]: this._isExtensionEnabled(
                    CODE.CODE_VITUSVET
                ), // Vitus vet
                [CODE.CODE_WEAVE]: this._isExtensionEnabled(CODE.CODE_WEAVE), // Weave
                zoetis_fuse: this._isExtensionEnabled(CODE.CODE_ABAXIS_FUSE) // Zoetis Fuse
            };

            // eslint-disable-next-line
            pendo.initialize({
                visitor: {
                    id: currentActor.id,
                    email: currentActor.email,
                    full_name: currentActor.fullname,
                    role: currentActor.role_label,
                    environment: process.env.VUE_APP_ENV,
                    userAgent: window.navigator.userAgent
                },
                account: {
                    id: setting.business_id,
                    name: setting.business.name,
                    state: setting.business.state,
                    country: setting.business.country,
                    environment: process.env.VUE_APP_ENV,
                    extensions,
                    feature_flag: setting.feature_flag
                }
            });
        },
        contactSupport() {
            window.Intercom("show");
        },
        toggleAppNotifications() {
            this.$refs.appNotification.show();
        },
        initGlobalToaster() {
            const baseAlert = {
                background: "#146c43",
                duration: 4000,
                className: "vetter-alert",
                dismissible: true
            };

            // eslint-disable-next-line no-undef
            window.toast = new Notyf({
                ripple: false,
                position: {
                    x: "right",
                    y: "top"
                },
                types: [
                    {
                        // intially for notification banner
                        type: "banner",
                        background: "white",
                        icon: false,
                        duration: 4500,
                        dismissible: true,
                        className: "vetter-toast-banner"
                    },
                    {
                        ...baseAlert,
                        type: "success",
                        background: "#198754",
                        icon: {
                            className: "fa fa-check-circle",
                            tagName: "i"
                        }
                    },
                    {
                        ...baseAlert,
                        type: "danger",
                        background: "#dc3545",
                        duration: 0, // manual close
                        icon: {
                            className: "fa fa-exclamation-circle",
                            tagName: "i"
                        }
                    },
                    {
                        ...baseAlert,
                        type: "warning",
                        background: "#cc9a06",
                        icon: {
                            className: "fa fa-exclamation-triangle",
                            tagName: "i"
                        }
                    },
                    {
                        ...baseAlert,
                        type: "info",
                        background: "#0d6efd",
                        icon: {
                            className: "fa fa-info-circle",
                            tagName: "i"
                        }
                    }
                ]
            });

            window.toast.notification = function (type, message) {
                function extractVisibleText(htmlString) {
                    const tempElement = document.createElement("div");
                    tempElement.innerHTML = htmlString;
                    return (
                        tempElement.textContent || tempElement.innerText || ""
                    );
                }

                let visibleMessage = extractVisibleText(message);
                let isExceeded = visibleMessage.length > 100;

                window.toast.open({
                    type: "banner",
                    message: `
                    <span class="title">New Notification</span>
                    <div class="content ${isExceeded ? "fade-bottom" : ""}">
                        <i class="fa ${notificationIcons[type]}"></i>
                        <span class="message">${message}</span>
                    </div>`
                });
            };

            // dynamic position
            let selector = document.querySelectorAll(".notyf");
            let notyf = selector[0];
            const INDICATOR = 100;

            if (document.body.scrollTop < INDICATOR) {
                notyf.style.top = INDICATOR + "px";
            } else {
                notyf.style.top = 0;
            }

            window.onscroll = function () {
                if (window.scrollY > INDICATOR) {
                    notyf.style.top = 0;
                } else {
                    notyf.style.top = INDICATOR + "px";
                }
            };
        },
        async handleReceiveNotification(params) {
            this.$store.dispatch(
                "notification/updateBadgeCountByArray",
                params.message || []
            );

            if (params.content && params.type) {
                let isShowBanner = await this.$store.dispatch(
                    "userPreferences/isShowNotificationBanner",
                    params.type
                );

                if (isShowBanner) {
                    window.toast.notification(params.type, params.content);
                }
            }
        },
        refreshCISession(to, from, next) {
            $.getJSON(process.env.APPS + "index.php/ajax/staff/id")
                .then(response => {
                    if (!get(response, "id")) {
                        setTimeout(function () {
                            if (typeof newrelic !== "undefined") {
                                // eslint-disable-next-line no-undef
                                newrelic.addPageAction("view-logout", {
                                    reason: "session",
                                    file: "index.vue > refreshCISession no id"
                                });
                            }
                            if (window.location.port != "8080") {
                                window.location =
                                    process.env.APPS +
                                    "index.php/welcome/logout?f=3";
                            }
                        }, 1000);
                        next(false);
                    }
                })
                .catch(err => {
                    console.error(err.statusText);
                    setTimeout(function () {
                        if (typeof newrelic !== "undefined") {
                            // eslint-disable-next-line no-undef
                            newrelic.addPageAction("view-logout", {
                                reason: "session",
                                file: "index.vue > refreshCISession catch"
                            });
                        }
                        if (window.location.port != "8080") {
                            window.location =
                                process.env.APPS +
                                "index.php/welcome/logout?f=3";
                        }
                    }, 1000);
                    next(false);
                });
        },
        initShortcutKey(event) {
            let isScreenLocked = document.getElementById("lockDeviceModal")
                ? true
                : false;

            if (isScreenLocked) {
                return;
            }

            if (event.key === "F12" && event.shiftKey) {
                event.preventDefault();
                this.$bvModal.show("lockDeviceModal");
                return;
            }

            if (event.key === "F1" && event.shiftKey) {
                event.preventDefault();
                this.contactSupport();
                return;
            }
        },
        getActorInitials(actor) {
            let a = actor?.firstname?.[0];
            let b = actor?.lastname?.[0];

            if (a && b) {
                let intials = `${a}.${b}`.toUpperCase();
                return intials;
            }
            return "";
        },
        handleHeaderNotificationVisibility() {
            if (!window.matchMedia("(min-width: 992px)").matches) {
                return;
            }

            this.$nextTick(() => {
                let banner =
                    document.getElementById("notification-navbar") ||
                    document.getElementById("notification-header");

                let bannerHeight = banner?.offsetHeight ?? 0;

                let primaryBar = document.getElementById("app-primary-nav");
                if (primaryBar) {
                    if (bannerHeight === 0) {
                        primaryBar.style.top = "";
                    } else {
                        primaryBar.style.top = `${bannerHeight}px`;
                    }
                }

                let selectors = [
                    ".route-main-view > .module-navbar",
                    ".route-main-view > div > .module-navbar"
                ];

                let secondaryBar = document.querySelector(selectors[0]);
                if (!secondaryBar) {
                    secondaryBar = document.querySelector(selectors[1]);
                }

                if (secondaryBar) {
                    let value = primaryBar.offsetHeight + bannerHeight;
                    secondaryBar.style.top = value + "px";
                }

                let routeMainView = document.querySelector(".route-main-view");
                if (routeMainView) {
                    let value =
                        primaryBar.offsetHeight +
                        secondaryBar.offsetHeight +
                        bannerHeight;
                    routeMainView.style.paddingTop = value + "px";
                }
            });
        },
        openWorkramp() {
            const SUCCESS_MESSAGE = "Redirecting to Workramp.";
            const ERR_MESSAGE = "Unable to connect Workramp.";
            return this.$http
                .get(process.env.BARRAMUNDI + "actor/workramp")
                .then(response => {
                    if (response?.data?.response?.code == 200) {
                        let data = response.data.response.resource;
                        // open new window
                        this._message(SUCCESS_MESSAGE, "success");
                        window.open(data, "_blank");
                    } else {
                        this._message(ERR_MESSAGE, "danger");
                    }
                });
        }
    },
    beforeDestroy() {
        clearInterval(this.switcher_event);
        document.removeEventListener("keydown", this.initShortcutKey);
        this.$store.commit("billing/setUsersChooseInvoice", []);
    }
};
</script>
